import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { Spinner } from "@discordforge/ui";
import { adminBoot, adminLogin, adminLogout } from "./api";
import { AdminLoginScreen } from "./AdminLogin";
import { AdminPanel } from "./AdminPanel";

export function AdminApp() {
    const [phase, setPhase] = useState<"booting" | "login" | "panel">("booting");
    const [bootError, setBootError] = useState("");

    /* On mount: check whether an admin session already exists (AdminAppData
     * returns Auth=true when the smadmin cookie is valid). */
    useEffect(() => {
        adminBoot()
            .then((data) => setPhase(data.Auth ? "panel" : "login"))
            .catch((err) => setBootError(err instanceof Error ? err.message : "Failed to boot"));
    }, []);

    const doLogin = async (login: string, password: string) => {
        const result = await adminLogin(login, password);
        if (!result.Auth) throw new Error("Invalid credentials");
        setPhase("panel");
    };

    const doLogout = async () => {
        try {
            await adminLogout();
        } finally {
            setPhase("login");
        }
    };

    if (phase === "booting") {
        return (
            <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[#0b0b0f] text-white">
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-orange-500/20 bg-orange-500/10 text-orange-400 shadow-[0_0_30px_rgba(249,115,22,0.2)]">
                    <ShieldCheck size={24} />
                </div>
                <Spinner size={24} label={bootError ? "Boot failed" : "Checking session…"} />
                {bootError && <p className="max-w-sm text-center text-sm text-red-400">{bootError}</p>}
            </div>
        );
    }

    if (phase === "login") {
        return <AdminLoginScreen onLogin={doLogin} />;
    }

    return <AdminPanel onLogout={doLogout} />;
}
